export default __webpack_public_path__ + "static/hero-tarifas-c28d5829fa0bc92b64c27c4354ca85bc.jpg";